import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicToolsService } from '@/infra/services/ergonomic-tool';

interface GetErgonomicToolListParams {
	organization_id: string;
	company_id: string;
	custom_report_id?: string[];
}

const Service = ErgonomicToolsService.getInstance();

export const useGetErgonomicToolList = (params: GetErgonomicToolListParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ERGONOMIC_TOOL_LIST, params],
		queryFn: () => Service.findAll(params),
		enabled: !!params.organization_id && !!params.company_id
	});
};
